module.exports = __webpack_public_path__ + "img/location.2fae1b68.svg";